export class CommissionFisofo {

  public commissionId?:number;

  public commissionGroupId?:number;
  public commissionGroupDescr?:string;

  public financingTypeId?:number;
  public financingTypeDescr?:string;

  public afiliateId?:string;
  public afiliateDescr?:string;

  public paymentId?:number;
  public paymentDescr?:string;

  public commission?:number;
  public commissionMax?:number;
  public commissionManager?:number;
  public commissionCoordinator?:number;
  public commissionRegional?:number;

  public rateMin?:number;
  public rateMax?:number;

  public advanceMin?:number;
  public advanceMax?:number;

  public collectCapitalAmountMin?:number;
  public collectCapitalAmountMax?:number;

  public createUserId?:number;
  public createUserName?:string;
  public createDate?:string;

  public modifUserId?:number;
  public modifUserName?:string;
  public modifDate?:string;

  public activeId?:boolean;
}
